// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const tooltip = "Tooltip__tooltip__u+wHs font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const arrow = "Tooltip__arrow__YZJUz";
export const arrowUpLeft = "Tooltip__arrowUpLeft__CtVzJ";
export const arrowUp = "Tooltip__arrowUp__re+vB";
export const arrowDown = "Tooltip__arrowDown__t6Eg4";
export const tooltipContent = "Tooltip__tooltipContent__jpuz+";
export const member = "Tooltip__member__aNf6X";
export const peers = "Tooltip__peers__+yyQY";
export const others = "Tooltip__others__NuggA";
export const success = "Tooltip__success__aRrmj";
export const warning = "Tooltip__warning__RQiHE";
export const danger = "Tooltip__danger__TbfNv";
export const failure = "Tooltip__failure__llQjA";
export const info = "Tooltip__info__nNqxc";
export const white = "Tooltip__white__Fr+Xm";
export const light = "Tooltip__light__yF0lt";
export const wrap = "Tooltip__wrap__ythtT";
export const incorrect = "Tooltip__incorrect__pm1pV";